import { X } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Alert } from '@/components/ui/alert'
import { MapPin, VectorPolygon } from 'lucide-react'
import type { ActiveTool, GeoreferenceValue } from './georeference-step'

type GeoreferenceStatusBarProps = {
  georeference: GeoreferenceValue
  activeTool: ActiveTool
  onClear: () => void
}

export const GeoreferenceStatusBar = ({
  georeference,
  activeTool,
  onClear,
}: GeoreferenceStatusBarProps) => {
  return (
    <Alert className="flex items-center gap-2 px-4 py-2 border-t bg-slate-50">
      <span className="my-2 flex-auto flex items-center gap-2 text-sm text-muted-foreground">
        {georeference.type === 'NONE' && (
          <>No location set — search, click the map, or draw an area</>
        )}
        {georeference.type === 'POINT' &&
          georeference.geometry &&
          georeference.geometry.type === 'Point' && (
            <>
              <MapPin></MapPin>
              <span>
                Pinned location:{' '}
                {georeference.geometry.coordinates.map((v) => v.toFixed(5)).join(', ')}
              </span>
            </>
          )}
        {georeference.type === 'POLYGON' && (
          <>
            <VectorPolygon></VectorPolygon>
            <span>Area drawn</span>
          </>
        )}
      </span>

      {georeference.type !== 'NONE' && (
        <Button className="flex-shrink-0" type="button" variant="ghost" size="sm" onClick={onClear}>
          <X className="h-3.5 w-3.5" />
          Clear
        </Button>
      )}
    </Alert>
  )
}
